import React, {FC} from 'react'
import {useIntl} from 'react-intl'

import {WizardData} from '../index'

interface Props {
  data: WizardData
  updateData?: (data: Partial<WizardData>) => void
  isDark: boolean
  importType: 'csv' | 'manual'
  primaryActionLabelId: string
  onPrimaryAction: () => void
  secondaryActionLabelId?: string
  onSecondaryAction?: () => void
  isLoading?: boolean
  showActionButtons?: boolean
  showWhatsNext?: boolean
}

const Step3SuccessSummary: FC<Props> = ({
  importType,
  primaryActionLabelId,
  onPrimaryAction,
  secondaryActionLabelId,
  onSecondaryAction,
  isLoading,
  showActionButtons = true,
  showWhatsNext = false,
}) => {
  const intl = useIntl()
  const title = intl.formatMessage({
    id:
      importType === 'csv'
        ? 'ONBOARDING_WIZARD.STEP3_SUMMARY.SETUP_COMPLETED_TITLE_CSV'
        : 'ONBOARDING_WIZARD.STEP3_SUMMARY.SETUP_COMPLETED_TITLE',
  })
  const description = intl.formatMessage({
    id:
      importType === 'csv'
        ? 'ONBOARDING_WIZARD.STEP3_SUMMARY.SETUP_COMPLETED_DESC_CSV'
        : 'ONBOARDING_WIZARD.STEP3_SUMMARY.SETUP_COMPLETED_DESC',
  })

  return (
    <div className='step3-success-summary'>
      <div className='step3-success-shell'>
        <div className='step3-success-card'>
          <div className='step3-success-icon-wrap'>
            <div className='step3-success-icon'>
              <i className='fas fa-check' aria-hidden='true'></i>
            </div>
          </div>
          <h2 className='step3-success-title'>{title}</h2>
          <p className='step3-success-desc'>{description}</p>

          {showWhatsNext && (
            <div className='step3-success-whats-next'>
              <div className='step3-success-whats-next-title'>
                {intl.formatMessage({
                  id: 'ONBOARDING_WIZARD.STEP3_SUMMARY.WHATS_NEXT_TITLE',
                })}
              </div>
              {importType === 'csv' ? (
                <div>
                  {intl.formatMessage({
                    id: 'ONBOARDING_WIZARD.STEP3_SUMMARY.WHATS_NEXT_CSV',
                  })}
                </div>
              ) : (
                <>
                  <div>
                    {intl.formatMessage({
                      id: 'ONBOARDING_WIZARD.STEP3_SUMMARY.WHATS_NEXT_LINE_1',
                    })}
                  </div>
                  <div>
                    {intl.formatMessage({
                      id: 'ONBOARDING_WIZARD.STEP3_SUMMARY.WHATS_NEXT_LINE_2',
                    })}
                  </div>
                  <div>
                    {intl.formatMessage({
                      id: 'ONBOARDING_WIZARD.STEP3_SUMMARY.WHATS_NEXT_LINE_3',
                    })}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {showActionButtons && (
          <div className='step3-success-actions'>
            <button
              type='button'
              className='btn btn-primary onboarding-btn-next step3-success-cta'
              onClick={onPrimaryAction}
              disabled={!!isLoading}
            >
              {isLoading
                ? intl.formatMessage({id: 'ONBOARDING_WIZARD.LOADING'})
                : intl.formatMessage({id: primaryActionLabelId})}
              <i className='fas fa-arrow-right ms-2' aria-hidden='true'></i>
            </button>
            {secondaryActionLabelId && onSecondaryAction && (
              <button
                type='button'
                className='btn btn-light step3-success-cta step3-success-cta-secondary'
                onClick={onSecondaryAction}
                disabled={!!isLoading}
              >
                {intl.formatMessage({id: secondaryActionLabelId})}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Step3SuccessSummary
